import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  CharacterSheetInterface,
} from "@dndModels";

import CharacterDefensesButton from "@dndComponents/character/defenses/CharacterDefensesButton";

interface Props {
  char: CharacterSheetInterface;
  disabled?: boolean;
  shared: boolean;
}

// const api = API.getInstance();

export default function CharacterDefenses({ 
  char,
  disabled = false,
  shared,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = () => {
    console.log("Defenses");
    setReloading(true);
  }

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    }
  });
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderMultipliers = (mult: number) => {
    const multipliers = char.mind.getDTsForMultiplier(mult); // .damage_multipliers.filter(o => o.multiplier === mult);
    if (multipliers.length > 0) {
      const label = mult === 0.5 ? "Resistance" : (mult === 0 ? "Immunity" : "Vulnerability");
      return (
        <>
          <Grid size={12} style={{ paddingLeft: "4px" }}>
            <span className="header">{ label }:&nbsp;</span>
            { multipliers.map(o => o).join(", ") }
          </Grid>
        </>
      );
    }
    return null;
  }

  return (
    <Grid className="curved_border bg_black_transp">
      <div>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <CharacterDefensesButton
              char={char}
              disabled={disabled || shared}
              onChange={() => {
                char.subscription_holder.recalculate();
                setReloading(true);
              }}
            />
          </Grid>
          { renderMultipliers(0) }
          { renderMultipliers(0.5) }
          { renderMultipliers(2) }
        </Grid>
      </div>
    </Grid>
  );
}
